export default __webpack_public_path__ + "4637eb2d8d6db802f7537257ca346910.woff2";